import { CaretRight } from '@phosphor-icons/react/ssr';
import { cn } from '@reelplicate/ui/lib/utils';
import { Slot } from 'radix-ui';
import type * as React from 'react';

// Vendored shadcn breadcrumb, stripped to structure: the Figma styling
// (Breadcrumb, Breadcrumb Item, Separator, Overflow) lives in
// components/lib/breadcrumb.tsx.

function Breadcrumb({
  'aria-label': ariaLabel = 'Breadcrumb',
  ...props
}: React.ComponentProps<'nav'>) {
  return <nav aria-label={ariaLabel} data-slot="breadcrumb" {...props} />;
}

function BreadcrumbList({ className, ...props }: React.ComponentProps<'ol'>) {
  return (
    <ol
      data-slot="breadcrumb-list"
      className={cn('flex flex-wrap items-center', className)}
      {...props}
    />
  );
}

function BreadcrumbItem({ className, ...props }: React.ComponentProps<'li'>) {
  return (
    <li
      data-slot="breadcrumb-item"
      className={cn('inline-flex min-w-0 items-center', className)}
      {...props}
    />
  );
}

function BreadcrumbLink({
  asChild,
  ...props
}: React.ComponentProps<'a'> & {
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot.Root : 'a';
  return <Comp data-slot="breadcrumb-link" {...props} />;
}

/** The current page: not a link. */
function BreadcrumbPage(props: React.ComponentProps<'span'>) {
  return <span data-slot="breadcrumb-page" aria-current="page" {...props} />;
}

function BreadcrumbSeparator({ children, ...props }: React.ComponentProps<'li'>) {
  return (
    <li
      data-slot="breadcrumb-separator"
      role="presentation"
      aria-hidden="true"
      {...props}
    >
      {children ?? <CaretRight />}
    </li>
  );
}

export {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
};
